import { Alert, Spin, Typography } from 'antd'
import React, { useEffect } from 'react'
import * as Sentry from '@sentry/browser'
import { useTranslation } from 'react-i18next'

const spinnerStyle = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
}
interface LoadProps {
  load?: any
  error: any
}
const LoadError: React.FC<LoadProps> = ({ load, error }): JSX.Element => {
  const { t } = useTranslation()

  useEffect(() => {
    if (error) {
      console.error(error)
      Sentry.captureException(error)
    }
  }, [error])

  if (load) {
    return (
      <div style={spinnerStyle}>
        <Spin />
      </div>
    )
  }

  return (
    <Alert
      message={
        <>
          <Typography.Text>{t('general.error', 'Something went wrong...')}</Typography.Text>
          <span>😞</span>
        </>
      }
      showIcon
      type={'error'}
      closable
    />
  )
}

export default LoadError
